// This will remove all leading and trailing spaces + all tabs, new lines and multiple spaces inside the string
export const spaceCleaner = (text: string): string => text.replace(/\s\s+/g, " ").trim();

export default spaceCleaner;
